import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=3b1e2bd0&"
import script from "./Reserved.vue?vue&type=script&lang=js&"
export * from "./Reserved.vue?vue&type=script&lang=js&"
import style0 from "./Reserved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports